<div>
    {{( header | translate)}}
</div>
<div *ngIf="showAllDataAvailable" class="hidden-content-notification">
    {{showAllDataCount}} {{'HIDDEN_ITEMS' | translate}}
</div>


